import { IStores } from '.'
import { observable, action, computed } from 'mobx'

export interface IFeedbackChoice {
  text: string
  type: string
  reference: string
}

export interface IFeedback {
  multiSelectionAllowed: boolean
  reference: string
  question: string
  choices: Array<IFeedbackChoice>
}

class FeedbackStore {
  store: IStores

  @observable loading = false
  @observable data: IFeedback | null = null
  @observable selectedChoices: Array<string> = []
  @observable isFeedbackModalOpen = false
  @observable singleSelectInputValue = ''
  @observable multiSelectInputValuesMap: Map<string, string> = new Map()

  constructor(store: IStores) {
    this.store = store
  }

  @computed get choices() {
    return this.data?.choices || []
  }

  @computed get multiSelectionAllowed() {
    return this.data?.multiSelectionAllowed
  }

  @computed get question() {
    return this.data?.question
  }

  @action reset = () => {
    this.loading = true

    this.loading = false
  };
}

export default FeedbackStore
